import { Api, ModelRow } from "@mcleod/core";
import { AutogenLayoutClientLicenseUtility } from "./autogen/AutogenLayoutClientLicenseUtility";
import { DataSourceExecutionEvent, ClickEvent, Snackbar, MainPageAccessor } from "@mcleod/components";
import { CommonDialogs } from "./CommonDialogs";

export class ClientLicenseUtility extends AutogenLayoutClientLicenseUtility {

    /** This is an event handler for the afterExecution event of sourceClientRegistration. */
    sourceClientRegistrationAfterExecution(event: DataSourceExecutionEvent) {
        this.sourceClientRegistration.activeRow?.set("licenses_total", this.sourceClientRegistration.summaryData.get("licenses_total"));
        this.sourceClientRegistration.activeRow?.set("licenses_used", this.sourceClientRegistration.summaryData.get("licenses_used"));
        this.sourceClientRegistration.activeRow?.set("licenses_total_admin", this.sourceClientRegistration.summaryData.get("licenses_total_admin"));
        this.sourceClientRegistration.activeRow?.set("licenses_admin", this.sourceClientRegistration.summaryData.get("licenses_admin"));
        this.sourceClientRegistration.activeRow?.set("licenses_support", this.sourceClientRegistration.summaryData.get("licenses_support"));
    }

    /** This is an event handler for the onClick event of buttonRefresh. */
    buttonRefreshOnClick(event: ClickEvent) {
        this.labelLicensesAdminValue.text = null;
        this.labelLicensesTotalValue.text = null;
        this.labelLicensesUsedValue.text = null;
        this.sourceClientRegistration.search();
    }

    /** This is an event handler for the onClick event of buttonClean. */
    async buttonCleanOnClick(event: ClickEvent) {
        const progressSnack: Snackbar = Snackbar.showDownloadSnackbar(
            "Cleaning license count",
            "Removing improperly disconnected clients",
            { targetPanel: MainPageAccessor.router, persist: true }
        );

        try {
            const response = await Api.post("common/client-license-utility/clean");
            progressSnack.dismiss();
            const success = response?.data?.[0]?.success;
            const message = response?.data?.[0]?.message;
            if (success) {
                await CommonDialogs.showMessage({ text: "Improperly disconnected clients have been removed", imageName: "disk", fontBold: true });
                this.sourceClientRegistration.search();
            } else {
                await CommonDialogs.showMessage(message == null ? "" : message, "Client license clean failed", { fontBold: true });
            }
        } catch (err) {
            progressSnack.dismiss();
            await CommonDialogs.showMessage({ text: "Client license clean failed: " + err, imageName: "disk", fontBold: true });
        }
    }

    /** This is an event handler for the onClick event of buttonClose. */
    async buttonCloseOnClick(event: ClickEvent) {
        const modelRow = this.tableClientLicenseUtility.selectedRow.data as ModelRow;
        const vmIdentifier = modelRow.get("vm_identifier");

        const progressSnack: Snackbar = Snackbar.showDownloadSnackbar(
            "Closing client",
            "Closing selected remote application",
            { targetPanel: MainPageAccessor.router, persist: true }
        );

        try {
            const response = await Api.post("common/client-license-utility/close", { vm_identifier: vmIdentifier });
            progressSnack.dismiss();
            const success = response?.data?.[0]?.success;
            const message = response?.data?.[0]?.message;
            if (success) {
                await CommonDialogs.showMessage({ text: "Client successfully closed", imageName: "disk", fontBold: true });
                this.sourceClientRegistration.search();
            } else {
                await CommonDialogs.showMessage(message == null ? "" : message, "Failed to close client", { fontBold: true });
            }
        } catch (err) {
            progressSnack.dismiss();
            await CommonDialogs.showMessage({ text: "Failed to close client: " + err, imageName: "disk", fontBold: true });
        }

    }
}
